import { useContext } from 'react';
import { UserContext } from '../../userAlertContext';

// Incident Alert provides its local counterpart; shared views consume one shape.
export function useAccommodationUser(userOverride) {
  const context = useContext(UserContext) || {};
  if (!userOverride) return context;
  return userOverride.user ? { ...context, ...userOverride } : { ...context, user: userOverride };
}
